const pathObj = {
  loginUser: '/v2/user/login',
  loginUserSmartfin: '/v2/external/smartfin/login-from-smartfin',
  loginWithSmartfin: '/v2/external/smartfin/login-with-smartfin',

  changeUserWallet: '/v2/user/change-user-wallet',
  getCurrencies: '/v2/user/wallet/currencies',
  addWallet: '/v2/user/wallet/add-wallet',
  walletBalanceWindow: '/v2/user/wallet/wallet-balance-window',
  changeUserAccount: '/v2/user/change-user-account',
  
  pendingEAlbaniaTransactions: '/v2/user/wallet/pending-ealbania-transactions',
  pendingEAlbaniaTransactionDetails: '/v2/user/wallet/pending-ealbania-transaction-by-id',
  pendingEAlbaniaTransactionSendOTP: '/v2/user/wallet/pending-ealbania-invoice-send-otp',
  finishedEAlbaniaTransactions: '/v2/user/wallet/finished-ealbania-transactions',
  payEAlbaniaTransaction: '/v2/user/wallet/pay-ealbania-transaction',

  pendingSmartfinTransactionDetails: '/v2/user/wallet/pending-smartfin-order-by-id',
  pendingSmartfinTransactionSendOTP: '/v2/user/wallet/pending-smartfin-order-send-otp',
  finishedSmartfinTransactions: '/v2/user/wallet/finished-smartfin-transactions',
  paySmartfinTransaction: '/v2/user/wallet/pay-smartfin-order',
  
  myCards: '/v2/user/card/list',
  deleteCard: '/v2/user/card/delete',
  addCard: '/v2/user/card/add',

  //transfer money
  transferOTP: '/v2/user/wallet/transfer/otp',
  transferBetweenWallets: '/v2/user/wallet/transfer/wallet',
  transferToUsername: '/v2/user/wallet/transfer/username',
  transferToQRCode: '/v2/user/wallet/transfer/qrcode',
  transferCashOut: '/v2/user/wallet/transfer/cash-out',
  transferBankAaccount: '/v2/user/wallet/transfer/bank-account',

  transactionDetails: '/v2/user/wallet/wallet-transaction-details',

  loginEmailUser: '/v2/user/emailLogin',
  addMoney: '/v2/user/wallet/add-money',
  getBalance: '/v2/user/wallet/balance',
  changePassword: 'v2/user/change-password',
  notificationToggle: 'v2/user/notification-toggle',
  sendMoneyToMobile: '/v2/user/wallet/transfer/mobile',
  thirdPartyInvoicePayment: '/v2/user/wallet/third-party-invoice-payment',
  thirdPartySendOTPForInvoicePayment:
    '/v2/user/wallet/third-party-invoice-payment-send-otp',
  sendMoneyToBank: '/v2/user/wallet/transfer/bank-account',
  getProfile: '/v2/user/my-profile',
  updateProfile: '/v2/user/update-profile',
  deleteAccountRequest: '/v2/user/request-delete',
  myLoyaltyPoints: 'v2/user/my-loyalty-points',
  giftCard: 'v2/user/gift-card',
  redeemGiftCard: 'v2/user/redeem-gift-card',
  staticContent: 'v2/user/static-content/list',
  staticContentSlug: 'v2/user/static-content?slug',
  contactUs: 'v2/user/contact-us',
  signupUser: '/v2/user/signup',
  securityPin: '/v2/user/set-security-pin',
  promoCodes: '/v2/user/promo-codes',
  sentGiftCards: '/v2/user/sent-gift-cards',
  walletStatement: '/v2/user/wallet/statement',
  walletAddMoney: '/v2/user/wallet/add-money',
  forgotPassword: '/v2/user/forgot-password',
  forgotPasswordOtp: '/v2/user/reset-password',
  getFaqs: '/v2/user/static-content/faqs',
  verifyOtp: '/v2/user/verify-email-mobile',
  resendOtp: '/v2/user/resend-otp',
  customerQrCode: '/v2/user/customer-qr-code',
  transaction: '/v2/user/transaction',
  pendingInvoices: '/v2/user/wallet/pending-ealbania-transactions',
  nearbyMerchants: '/v2/user/nearby-merchants',
  getCategorySubCategoryList: '/v2/merchant/list',
  getNotifications: '/v2/user/notifications',
  postDeals: '/v2/user/offers/deals-purchase',
  loyaltyConvert: '/v2/user/loyalty-convert',
  promoCode: '/v2/user/wallet/check-promo-code',
  cashOutPreview: '/v2/merchant/wallet/cash-out-preview',
  cashOut: '/v2/user/wallet/transfer/cash-out',
  getInvoice: '/v2/user/wallet/invoice',
  verifyBankAccount: '/v2/user/loans/verify-bank-account',
  checkMaxLoanAmount: '/v2/user/loans/check-max-loan-amount',
  previewLoan: '/v2/user/loans/preview',
  submitLoanRequirement: '/v2/user/loans/submit-loan-requirement',
  loanStatus: '/v2/user/loans',
  bankList: '/v2/user/wallet/bank-accounts',
  bankCommission: '/v2/user/wallet/transfer-commissions',
  transferToBank: '/v2/user/wallet/transfer-to-bank',
  loanPreview: '/v2/user/loans/preview-installment',
  updateSecondaryEmail: '/v2/user/update-secondary-email',
  verifySecondaryEmail: '/v2/user/verify-otp-secondary-email',
  deleteSecondaryEmail: '/v2/user/delete-secondary-email',
  changePrimaryEmail: '/v2/user/change-primary-email',
  updateSecondaryMobile: '/v2/user/update-secondary-mobile',
  verifySecondaryMobile: '/v2/user/verify-otp-secondary-mobile',
  deleteSecondaryMobile: '/v2/user/delete-secondary-mobile',
  changePrimaryMobile: '/v2/user/change-primary-number',
  sendOTPTransferMoney: '/v2/user/wallet/transfer/otp',
  ssoLogin: '/v2/user/sso-verify-token',
  loanPay: '/v2/user/loans/pay-installment',
  verifyLoginOtp: '/v2/user/verify-otp',
  verifyEmailLoginOtp: '/v2/user/verify-email-otp',
  getSettings: '/v2/user/currency/get-settings-info'
}

export default pathObj
